import { AxiosInstance } from 'axios';

import { T_StaticJson } from '@/types';

export class JSONConfigService {
  private agent: AxiosInstance;
  constructor(agent: AxiosInstance) {
    this.agent = agent;
  }
  public getConfig = async () => {
    let { data } = await this.agent.get('');
    return data;
  };
}

export class StaticJsonConfigService {
  private readonly agent: AxiosInstance;
  constructor(agent: AxiosInstance) {
    this.agent = agent;
  }
  // this was added for getting address normalization data (part of Logistics hop-2) from static json file, needs to be moved to NBJ.
  public staticJson = async () => {
    const { data } = await this.agent.get<T_StaticJson[]>(`/my-account/static-json`, {});
    return data;
  };
}
